/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type ClientPhotoFullBodyCreateMutationVariables = Types.Exact<{
  input: Types.ClientPhotoFullBodyCreateInput;
}>;
export type ClientPhotoFullBodyCreateMutation = {
  __typename?: "Mutation";
  clientPhotoFullBodyCreate?: {
    __typename?: "ClientPhotoFullBodyCreatePayload";
    result: {
      __typename?: "ClientPhotoFullBodyCreateError";
      code: Types.ClientPhotoFullBodyCreateErrorCode;
      message?: string | null;
    } | {
      __typename?: "ClientPhotoFullBodyCreateSuccess";
      clientPhoto: {
        __typename?: "ClientPhoto";
        id: string;
        image: {
          __typename?: "Image";
          baseUrl: string;
          mediaPath: string;
          altText: string;
          width?: number | null;
          height?: number | null;
        };
      };
    };
  } | null;
};
export const ClientPhotoFullBodyCreateDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "clientPhotoFullBodyCreate"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "ClientPhotoFullBodyCreateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "clientPhotoFullBodyCreate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientPhotoFullBodyCreateSuccess"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "clientPhoto"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "id"
                        }
                      }, {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "image"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "baseUrl"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "mediaPath"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "altText"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "width"
                            }
                          }, {
                            kind: "Field",
                            name: {
                              kind: "Name",
                              value: "height"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }, {
                kind: "InlineFragment",
                typeCondition: {
                  kind: "NamedType",
                  name: {
                    kind: "Name",
                    value: "ClientPhotoFullBodyCreateError"
                  }
                },
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "code"
                    }
                  }, {
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "message"
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type ClientPhotoFullBodyCreateMutationFn = Apollo.MutationFunction<ClientPhotoFullBodyCreateMutation, ClientPhotoFullBodyCreateMutationVariables>;

/**
 * __useClientPhotoFullBodyCreateMutation__
 *
 * To run a mutation, you first call `useClientPhotoFullBodyCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientPhotoFullBodyCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientPhotoFullBodyCreateMutation, { data, loading, error }] = useClientPhotoFullBodyCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClientPhotoFullBodyCreateMutation(baseOptions?: Apollo.MutationHookOptions<ClientPhotoFullBodyCreateMutation, ClientPhotoFullBodyCreateMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<ClientPhotoFullBodyCreateMutation, ClientPhotoFullBodyCreateMutationVariables>(ClientPhotoFullBodyCreateDocument, options);
}
export type ClientPhotoFullBodyCreateMutationHookResult = ReturnType<typeof useClientPhotoFullBodyCreateMutation>;
export type ClientPhotoFullBodyCreateMutationResult = Apollo.MutationResult<ClientPhotoFullBodyCreateMutation>;
export type ClientPhotoFullBodyCreateMutationOptions = Apollo.BaseMutationOptions<ClientPhotoFullBodyCreateMutation, ClientPhotoFullBodyCreateMutationVariables>;